
<template>
     <a-select show-search :value="value" placeholder="输入3个字符以上的关键字搜索服务"  allow-clear style="width: 100%;"
         :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="fetching ? undefined : null"
         @search="handleSearch" @change="handleChange">
         <a-spin v-if="fetching" slot="notFoundContent" size="small" />
         <a-select-option v-for="d in data" :key="d.value">
             {{ d.text }}
         </a-select-option>
     </a-select>
</template>
<script>

export default {
    data() {
        return {
            data: [],
            searchTimmer:null,
            value:undefined,
            fetching:false
        }
    },

    props:{
    },

    methods: {
    
        handleChange(value) {
            this.value = value;
            this.$emit('onUrlCodeChange',value);
        },
        handleSearch(value) {
            let that = this;
            if(value.length <= 3){
                return
            }
            if(that.searchTimmer){
                clearTimeout(that.searchTimmer)
                that.searchTimmer = null;
            }
            that.searchTimmer = setTimeout(() => {
                that.doSearch(value);
                that.searchTimmer = null;
            }, 500);
        },

        doSearch(value){
            let that = this;
            
            let params = {
                keyword:value,
                lcount:20,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/gethistoryurls",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.data = [];
                    let result = res.data.data;
                    result.forEach(r => {
                        that.data.push({
                            value: r.url,
                            text: r.url,
                        });
                    });
                }
                that.fetching = false;
            }).catch(() => {
                that.fetching = false;

            });
        },

        setDefaultValue(defaultValue){
            this.value = defaultValue;
        }
    },
    mounted(){
        
    },

};
</script>

<style scoped>

</style>
